"use strict";

exports.__esModule = true;
exports["default"] = stateId;

function stateId() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];

  return state + 1;
}

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../~/dnd-core/lib/reducers/stateId.js
// module id = 514
// module chunks = 0